import { Box, Typography } from "@mui/material";
import { ActiveIcon } from "../../../assets/icons/MUI/ChatIcons";
import { EntityInfo } from "../../../types";

const ChatHeader = ({ sendToUser, isActive }: { sendToUser: EntityInfo; isActive: boolean }) => {
  const { firstName, lastName } = sendToUser;

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "5px",
          borderBottom: "1px solid #EAECF0",
          padding: "30px 25px 9px",
          width: "100%",
        }}
      >
        <Typography variant="body16SemiBold" sx={{ marginBottom: "4px" }}>
          {firstName && lastName ? `${firstName} ${lastName}` : ""}
        </Typography>
        {isActive ? (
          <Typography variant="body14Regular" sx={{ display: "flex", columnGap: "8px", alignItems: "center" }}>
            <ActiveIcon
              fill="none"
              sx={{
                width: "8px",
                height: "8px",
              }}
            />
            Active
          </Typography>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};

export default ChatHeader;
